import React, { useState,useRef } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table, List, ListItem, Checkbox, FormControlLabel,
    TableHead,
    TableBody, Card,
    TableCell,
    FormLabel, FormGroup, FormHelperText
} from "@material-ui/core";
import Modal from '@material-ui/core/Modal';
import Alert from '@material-ui/lab/Alert';
import poster from "../../../src/images/poster.jpg"
import ParkService from "./Locality/Service/parkService";
import EventService from "./Locality/Service/eventService";
import * as Yup from 'yup';
import TicketBookingService from "./Locality/Service/ticketBookingService";
import Canvas from './Canvas'
import { Typography } from "../../components/Wrappers/Wrappers";
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";

import { withStyles, makeStyles } from '@material-ui/core/styles';
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(255, 107, 129)",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function AddEvent() {
    const tableHeaders = [
        'Event Name', 
        'Status', 
        'Location', 
        'Adult Fee', 
        'Child Fee',
        // 'VIP Adult Fee',
        // 'VIP Kid Fee',
        // 'GA Adult Fee',
        // 'GA Kid Fee',
        'Ticket Fee',
        // 'Two Wheeler Fee',
        // 'Four Wheeler Fee', 
        // 'Senior Citizen Fee', 
        // 'Women Fee',
        // 'Physically Challenged Fee', 
        // 'Camera Fee', 
        // 'Photography Fee',
        // 'Shooting Fee', 
        // 'Walker Fee',
        // 'Family Fee',  
        // 'Family Addon Fee',
        'MID', 
        'Coupon Enabled',
        'Custom Booking Dates',
        'Home Banner',
        'Edit', 
        'Delete',
        'QR-Code', 
        'Poster',
        'QR Name'
    ];
    const classes = useStyles();
    const canvasRef = useRef(null);
    const [parkList, setParkList] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [getParksList, setParks] = useState([]);
    const [qrCode, setQrCode] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const [isOpen, setIsOpen] = useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [modalStyle] = React.useState(getModalStyle);
    const [ticketBookingList, setTicketBookingList] = useState([]);
    const payment = [
        'ICICI',
        'paytm',
    ];
    const [state, setState] = React.useState({
        checkedA: true,
        checkedB: true,
        checkedF: true,
        checkedG: true,
    });
    const [park, setPark] = useState({
        eventId: '',
        parkName: '',
        status:'',
        location: '',
        company: '',    
        payment: '',
        familyAddon:'',
        mid:'',
        adult: false,
        ticket: false,
        child: false,
        vipadult: false,
        vipkid: false,
        gaadult: false,
        gakid: false,
        vipadultFee: '',
        vipkidFee: '',
        gaadultFee: '',
        gakidFee: '',
        adultFee: '',
        ticketFee: '',
        childFee: '',
        seniorCitizen: false,
        seniorCitizenFee: '',
        twowheeler:false,
        twowheelerFee: '',
        fourwheeler: false,
        fourwheelerFee: '',
        women: false,
        womenFee: '',
        physicallyChallenged: false,
        physicallyChallengedFee: '',
        camera: false,
        cameraFee: '',
        photography: false,
        photographyFee: '',
        shooting: false,
        shootingFee: '',
        walker: false,
        walkerFee: '',
        family: false,
        familyFee: '',
        familyAddon: false,
        familyAddonFee: '',
        qrName: '',
          startTime: '',
          endTime: '',
        note: '',
        isEnabledCoupon: false,
        isEnabledCustomBookingDates: false,
        bookingDates: [],
        isHomeBannerEnabled: false,
        homeBannerImage: '',

    });
    const [holidays, setHolidaysState] = React.useState({
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
        sun: false,
    });
    const [checkboxes, setCheckboxes] = useState({
        adult: false,
        ticket:false,
        child: false,
        seniorCitizen: false,
        women: false,
        physicallyChallenged: false,
        camera: false,
        photography: false,
        shooting: false,
        isCloakRoom: false,
        isHolidays: false,
        twowheeler:false,
        fourwheeler: false
    });
    const validationSchema = Yup.object().shape({
        eventId: Yup.string().required('Event ID is required'),
         status: Yup.string(),
         company: Yup.string(),
        mid: Yup.string().required('park name is required'),
        location: Yup.string().required('location is required'),
        adult: Yup.boolean(),
        ticket: Yup.boolean(),
        child: Yup.boolean(),
        adultFee: Yup.string(),
        ticketFee: Yup.string(),
        childFee: Yup.string(),
        seniorCitizen: Yup.boolean(),
        seniorCitizenFee: Yup.string(),
        women: Yup.boolean(),
        womenFee: Yup.string(),
        physicallyChallenged: Yup.boolean(),
        physicallyChallengedFee: Yup.string(),
        camera: Yup.boolean(),
        cameraFee: Yup.string(),
        photography: Yup.boolean(),
        photographyFee: Yup.string(),
        shooting: Yup.boolean(),
        shootingFee: Yup.string(),
        twowheeler:Yup.string(),
        twowheelerFee: Yup.string(),
        fourwheeler: Yup.string(),
        fourwheelerFee: Yup.string(),
        isCloakRoom: Yup.boolean(),
        isHolidays: Yup.boolean(),
        startTime: Yup.string(),
        endTime: Yup.string(),
        node: Yup.string(),
        qrName: Yup.string(),
    });
    function getModalStyle() {
        const top = 50 + rand();
        const left = 50 + rand();
      
        return {
          top: `${top}%`,
          left: `${left}%`,
          transform: `translate(-${top}%, -${left}%)`,
        };
      }
      function rand() {
        return Math.round(Math.random() * 20) - 10;
      }
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setCheckboxes((prevCheckboxes) => ({
            ...prevCheckboxes,
            [name]: checked,
        }));
    };

    const handleHolidaysChange = (event) => {
        setHolidaysState({
            ...holidays,
            [event.target.name]: event.target.checked,
        });
    };
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
  
    useEffect(() => {
       // getParkList();
    //    getParks();
       getProfileId();
       getEventList();
       // getQrCode()
        return () => {
            setParkList([]);
            setEventList([]);
            setQrCode([]);
           
        }
    }, []);
    const draw = (data) => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        // Clear the canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
  
        // Load the base image
        const baseImage = new Image();
        baseImage.onload = () => {
          ctx.drawImage(baseImage, 0, 0, canvas.width, canvas.height);
  
          // Load the image to be displayed on top
          const topImage = new Image();
          topImage.onload = () => {
            // Adjust the position of the top image as desired
            const x = 50; // X coordinate
            const y = 160;  // Y coordinate
            ctx.drawImage(topImage, x, y, topImage.width, topImage.height);
            
            // Draw park name with fixed positioning and text wrapping
            ctx.font = 'bold 20px Arial';
            ctx.fillStyle = 'black';
            ctx.textAlign = "center";
            ctx.textBaseline = "top";
            const imgcenter = canvas.width / 2;
            const maxWidth = canvas.width - 40; // Leave 20px margin on each side
            const lineHeight = 35;
            const startY = 30;
            
            // Function to wrap text if it's too long
            const wrapText = (text, x, y, maxWidth, lineHeight) => {
                const words = text.split(' ');
                let line = '';
                let currentY = y;
                
                for (let n = 0; n < words.length; n++) {
                    const testLine = line + words[n] + ' ';
                    const metrics = ctx.measureText(testLine);
                    const testWidth = metrics.width;
                    
                    if (testWidth > maxWidth && n > 0) {
                        ctx.fillText(line.trim(), x, currentY);
                        line = words[n] + ' ';
                        currentY += lineHeight;
                    } else {
                        line = testLine;
                    }
                }
                ctx.fillText(line.trim(), x, currentY);
            };
            
            wrapText(data.parkName, imgcenter, startY, maxWidth, lineHeight);
          };
          topImage.src = data.image; // Replace 'top_image.jpg' with your top image file
        };
        baseImage.src = poster ; // Replace 'base_image.jpg' with your base image file
       setTimeout(() => {
        handleDownload(data.parkName);
       }, 1500);
        
      };
    const handleOpen1 = (data) => {
        setOpen1(true);
        getPoster(data);
       
       
      };
      const handleDownload = (parkName) => {
        const canvas = canvasRef.current;
        const url = canvas.toDataURL('image/png');
        const a = document.createElement('a');
        a.href = url;
        a.download = parkName+'.png';
        a.click();
      };
      const handleClose1 = () => {
        setOpen1(false);
      };
    const getTicketBookingList = () => {
        TicketBookingService.getAllTicketBooking().then((res) => {
            setTicketBookingList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getProfileId = ()=>{
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
console.log(userDetails.role)

   const result = userDetails.role==="admin" ? null:userDetails.profileId;
   console.log(result)
        ParkService.addAllProfileId({profileRegistrationId:result }).then((res) => {
            setParkList(res);
    }).catch((err) => {
        // setError(err.message);
    });
}
    const getEventList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const profileId = userDetails.role === "admin" ? null : userDetails.profileId;
        
        EventService.getEvent({ profileRegistrationId: profileId }).then((res) => {
            setEventList(res);
        }).catch((err) => {
            console.error(err);
        });
    };
    const getQrCode = (data) => {
       
        ParkService.qrCode(data._id).then((res) => {
            
            if(res){
                const base64Data = res.image.replace(/^data:image\/\w+;base64,/, '');
                const imageBuffer = Buffer.from(base64Data, 'base64');
                // Create a blob URL for the binary buffer
                const blob = new Blob([imageBuffer]);
                const blobUrl = URL.createObjectURL(blob);
                // Create a link element and trigger the download
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = data.parkName+'.png'; // Change the file name and extension
                link.click();
            
                // Clean up the blob URL
                URL.revokeObjectURL(blobUrl);

            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getPoster = (data) => {
        ParkService.qrCode(data._id).then((res) => {
            
            if(res){
         res.parkName=data.parkName.toUpperCase();
                draw(res);

            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
        const toggleModal = () => {
          setIsOpen(!isOpen);
        
        };
        // const handleOpen = (status) => {
        //     if(status){
        //         setPark({
        //         teacherName: '',
        //     email: '',
        //     password:'',
        //     qualification: '',
        //     address: '',
        //     mobileNumber: '',
        //     classId: '',
        //     })
        //     }
         
        //       setOpen(true);
        //   };
    const handleOpen = (status) => {
        if(status){
            setPark({
                eventId: '',
                parkName: '',
                status:'',
                location: '',
                company: '',
                payment: '',
                familyAddon:'',
                mid:'',
                adult: false,
                ticket: false,
                child: false,
                vipadult: false,
                vipkid: false,
                gaadult: false,
                gakid: false,
                vipadultFee: '',
                vipkidFee: '',
                gaadultFee: '',
                gakidFee: '',
                adultFee: '',
                ticketFee: '',
                childFee: '',
                seniorCitizen: false,
                seniorCitizenFee: '',
                twowheeler:false,
                twowheelerFee: '',
                fourwheeler: false,
                fourwheelerFee: '',
                women: false,
                womenFee: '',
                physicallyChallenged: false,
                physicallyChallengedFee: '',
                camera: false,
                cameraFee: '',
                photography: false,
                photographyFee: '',
                shooting: false,
                shootingFee: '',
                walker: false,
                walkerFee: '',
                family: false,
                familyFee: '',
                familyAddon: false,
                familyAddonFee: '',
                startTime: '',
                endTime: '',
                note: '',
                qrName: '',
        })
        }
        setOpen(true);
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
    };
    const text = (
        <div  className={classes.paper}  style={{height:"100%", width:"100%"}}>
         
          
         
          <canvas ref={canvasRef} width={600} height={800}></canvas>
          
        </div>
      );
    const editPark = (park) => {
        // Ensure new fields are properly initialized
        let eventIdValue = '';
        let parkNameValue = park.parkName || '';
        
        if (park.eventId) {
            if (typeof park.eventId === 'object' && park.eventId._id) {
                // If eventId is populated, extract the _id and eventName
                eventIdValue = park.eventId._id.toString();
                // If parkName is not set, use the eventName from populated eventId
                if (!parkNameValue && park.eventId.eventName) {
                    parkNameValue = park.eventId.eventName;
                }
            } else {
                // If eventId is a string/ObjectId
                eventIdValue = park.eventId.toString();
            }
        }
        debugger
        const parkWithDefaults = {
            ...park,
            eventId: eventIdValue,
            parkName: parkNameValue,
            isEnabledCoupon: park.isEnabledCoupon || false,
            isEnabledCustomBookingDates: park.isEnabledCustomBookingDates || false,
            bookingDates: park.bookingDates || [],
            isHomeBannerEnabled: park.isHomeBannerEnabled || false,
            homeBannerImage: park.homeBannerImage || ''
        };
        
        setPark(parkWithDefaults);
        handleOpen();
        setHolidaysState({
        mon: park.holidayDays.includes("mon"),
        tue: park.holidayDays.includes("tue"),
        wed: park.holidayDays.includes("wed"),
        thu: park.holidayDays.includes("thu"),
        fri: park.holidayDays.includes("fri"),
        sat: park.holidayDays.includes("sat"),
        sun: park.holidayDays.includes("sun"),
    })

    }
 
    const deletePark = (parkdelete) => {
        if (parkdelete) {
            ParkService.deletePark(parkdelete).then((res) => {
                //getParkList();
                getProfileId()
                onSubmit()
            }).catch((err) => {
            });
        }
    };

    const formik = useFormik({
        initialValues: park,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.profileRegistrationId = userDetails.profileId;
            
            // Ensure eventId is included and is not empty string
            if (!values.eventId || values.eventId === '') {
                alert("Please select an Event");
                return;
            }
            
            // Log values to debug
            console.log("Form values before submission:", values);
            console.log("eventId value:", values.eventId);
            
            const objectData = Object.keys(holidays).map(key => {
                return holidays[key] ? key : '';
            })
            values.holidayDays = objectData.filter(item => item !== "").toString();

            if (park._id) {
                ParkService.upadePark(values).then((res) => {
                    handleClose();
                  //  getParkList();
                  getProfileId();
                    resetForm()
                    alert("Park Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                
                console.log(values)
                // values.holidayDays = holidays;
                
                const objectData = Object.keys(holidays).map(key => {
                    return holidays[key] ? key : '';
                })
                values.holidayDays = objectData.filter(item => item !== "").toString();

                ParkService.cretePark(values).then((res) => {
                    //getParkList();
                    getProfileId();
                    resetForm();
                    handleClose();
                    alert(" Park Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }

        },
    });
    return (
        <>
        
            <PageTitle title="Event " button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: '#ff6b81' }}> Add Event
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <Table className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {parkList.length > 0 ? (
                                    parkList.slice(pg * rpg, pg * rpg + rpg).map((park) => (
                                        <TableRow key={park._id}>
                                            <TableCell className="pl-3 fw-normal">
                                                {park.parkName || (park.eventId && typeof park.eventId === 'object' ? park.eventId.eventName : '-')}
                                            </TableCell>
                                            <TableCell>
                                                <span style={{ 
                                                    color: park.status ? '#4caf50' : '#f44336',
                                                    fontWeight: 'bold'
                                                }}>
                                                    {park.status ? 'Active' : 'Inactive'}
                                                </span>
                                            </TableCell>
                                            <TableCell className="pl-3 fw-normal">
                                                {park.location || '-'}
                                            </TableCell>
                                            <TableCell className="pl-3 fw-normal">
                                                {park.adultFee ? `₹${park.adultFee}` : '-'}
                                            </TableCell>
                                            <TableCell className="pl-3 fw-normal">
                                                {park.childFee ? `₹${park.childFee}` : '-'}
                                            </TableCell>
                                            <TableCell className="pl-3 fw-normal">
                                                {park.ticketFee ? `₹${park.ticketFee}` : '-'}
                                            </TableCell>
                                            <TableCell className="pl-3 fw-normal">
                                                {park.mid || '-'}
                                            </TableCell>
                                            

                                           
                                           
                                           
                                           
                                            <TableCell>
                                                {park.isEnabledCoupon ? (
                                                    <CheckIcon style={{ color: '#4caf50', fontSize: '24px' }} />
                                                ) : (
                                                    <CloseIcon style={{ color: '#f44336', fontSize: '24px' }} />
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    {park.isEnabledCustomBookingDates ? (
                                                        <CheckIcon style={{ color: '#4caf50', fontSize: '24px' }} />
                                                    ) : (
                                                        <CloseIcon style={{ color: '#f44336', fontSize: '24px' }} />
                                                    )}
                                                    {park.isEnabledCustomBookingDates && park.bookingDates && Array.isArray(park.bookingDates) && park.bookingDates.length > 0 && (
                                                        <span style={{ fontSize: '12px', color: '#666', marginLeft: '4px' }}>
                                                            {park.bookingDates.length} date(s)
                                                        </span>
                                                    )}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    {park.isHomeBannerEnabled ? (
                                                        <CheckIcon style={{ color: '#4caf50', fontSize: '24px' }} />
                                                    ) : (
                                                        <CloseIcon style={{ color: '#f44336', fontSize: '24px' }} />
                                                    )}
                                                    {park.isHomeBannerEnabled && park.homeBannerImage && (
                                                        <span style={{ fontSize: '12px', color: '#666', marginLeft: '4px' }}>
                                                            Image set
                                                        </span>
                                                    )}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <EditIcon 
                                                    style={{ cursor: 'pointer', color: '#ff6b81' }} 
                                                    onClick={() => editPark(park)} 
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <DeleteIcon 
                                                    style={{ cursor: 'pointer', color: '#f44336' }} 
                                                    onClick={() => {
                                                        if (window.confirm('Are you sure you want to delete this park?')) {
                                                            deletePark(park);
                                                        }
                                                    }} 
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Button 
                                                    variant="contained" 
                                                    onClick={() => getQrCode(park)} 
                                                    size="small" 
                                                    color="secondary" 
                                                    style={{ backgroundColor: '#ff6b81', minWidth: '80px' }}
                                                > 
                                                    Download 
                                                </Button>
                                            </TableCell>
                                            <TableCell>
                                                <Button 
                                                    variant="contained" 
                                                    onClick={() => handleOpen1(park)} 
                                                    size="small" 
                                                    color="secondary" 
                                                    style={{ backgroundColor: '#ff6b81', minWidth: '80px' }}
                                                > 
                                                    Poster 
                                                </Button>
                                            </TableCell>
                                            <TableCell className="pl-3 fw-normal">
                                                {park.qrName || '-'}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={tableHeaders.length} style={{ textAlign: 'center', padding: '40px' }}>
                                            <div style={{ color: '#666', fontSize: '16px' }}>
                                                No park data available
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 100, 1000]}
                            count={parkList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Event</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ width: 650 }}>
                    <TextField
                            style={{ width: 600 }}
                            id="company"
                            name="company"
                            label="Company"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.company}
                            error={formik.touched.company && Boolean(formik.errors.company)}
                            helperText={formik.touched.company && formik.errors.company}
                        />
                        <FormControl variant="standard" fullWidth style={{ width: 600 }}>
                            <InputLabel id="eventId-select-label">Event</InputLabel>
                            <Select
                                labelId="eventId-select-label"
                                id="eventId"
                                name="eventId"
                                value={formik.values.eventId}
                                onChange={(e) => {
                                    const selectedEvent = eventList.find(event => event._id === e.target.value);
                                    formik.setFieldValue('eventId', e.target.value);
                                    // Set parkName to eventName when event is selected
                                    if (selectedEvent && selectedEvent.eventName) {
                                        formik.setFieldValue('parkName', selectedEvent.eventName);
                                    } else {
                                        formik.setFieldValue('parkName', '');
                                    }
                                }}
                                error={formik.touched.eventId && Boolean(formik.errors.eventId)}
                                label="Event"
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {eventList.map((eventItem) => (
                                    <MenuItem key={eventItem._id} value={eventItem._id}>
                                        {eventItem.eventName}
                                    </MenuItem>
                                ))}
                            </Select>
                            {formik.touched.eventId && formik.errors.eventId && (
                                <Typography variant="caption" color="error" style={{ marginLeft: 14, marginTop: 4 }}>
                                    {formik.errors.eventId}
                                </Typography>
                            )}
                        </FormControl>
                         <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="status"
                                name="status"
                                value={formik.values.status}
                                onChange={formik.handleChange}
                                error={formik.touched.status && Boolean(formik.errors.status)}
                                helperText={formik.touched.status && formik.errors.status}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem value={true}>Active</MenuItem>
                                <MenuItem value={false}>In Active</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl
                                        //  className={classes.formControl}
                                            fullWidth="true" >
                                            <InputLabel id="demo-simple-select-label">Select Payment Method</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="payment"
                                                name="payment"
                                                label="payment"
                                                onChange={formik.handleChange}
                                                value={formik.values.payment}
                                                error={formik.touched.payment && Boolean(formik.errors.payment)}
                                                helperText={formik.touched.payment && formik.errors.payment}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                {payment.map((payment) => (
                                                    <MenuItem key={payment} selected={payment === 'Nursery'} value={payment}  >
                                                        {payment}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                        <TextField
                            style={{ width: 600 }}
                            id="mid"
                            name="mid"
                            label="Merchant Id"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.mid}
                            error={formik.touched.mid && Boolean(formik.errors.mid)}
                            helperText={formik.touched.mid && formik.errors.mid}
                        />
                        <TextField
                            style={{ width: 600 }}
                            id="location"
                            name="location"
                            label="Location"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.location}
                            error={formik.touched.location && Boolean(formik.errors.location)}
                            helperText={formik.touched.location && formik.errors.location}
                        />
                        {/* <TextField
                            style={{ width: 600 }}
                            id="adult"
                            name="adult"
                            label="Adult"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.adult}
                            error={formik.touched.adult && Boolean(formik.errors.adult)}
                            helperText={formik.touched.adult && formik.errors.adult}
                        /> */}
                        {/* <TextField
                            style={{ width: 600 }}
                            id="child"
                            name="child"
                            label="Child"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.child}
                            error={formik.touched.child && Boolean(formik.errors.child)}
                            helperText={formik.touched.child && formik.errors.child}
                        /> */}
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto" >
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox

                                        onChange={formik.handleChange}
                                        value={formik.values.adult}
                                        checked={formik.values.adult} name="adult" />}
                                    label="adult"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField
                                    style={{ width: 344 }}
                                    id="adultFee"
                                    name="adultFee"
                                    label="adult Fee"
                                    type="text"
                                    disabled={!formik.values.adult}
                                    onChange={formik.handleChange}
                                    value={formik.values.adultFee}
                                    error={formik.touched.adultFee && Boolean(formik.errors.adultFee)}
                                    helperText={formik.touched.adultFee && formik.errors.adultFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto" >
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.child}
                                        checked={formik.values.child}
                                        name="child" />}
                                    label="Child "
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField
                                    style={{ width: 344 }}
                                    id="childFee"
                                    name="childFee"
                                    label="Child Fee"
                                    type="text"
                                    disabled={!formik.values.child}
                                    onChange={formik.handleChange}
                                    value={formik.values.childFee}
                                    error={formik.touched.childFee && Boolean(formik.errors.childFee)}
                                    helperText={formik.touched.childFee && formik.errors.childFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto" >
                            <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox

                                        onChange={formik.handleChange}
                                        value={formik.values.ticket}
                                        checked={formik.values.ticket} name="ticket" />}
                                    label="ticket"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField
                                    style={{ width: 344 }}
                                    id="ticketFee"
                                    name="ticketFee"
                                    label="Ticket Fee"
                                    type="text"
                                    disabled={!formik.values.ticket}
                                    onChange={formik.handleChange}
                                    value={formik.values.ticketFee}
                                    error={formik.touched.ticketFee && Boolean(formik.errors.ticketFee)}
                                    helperText={formik.touched.ticketFee && formik.errors.ticketFee}
                                />
                            </Grid>
                        </Grid>
                        {/* <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto" >
                            <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox

                                        onChange={formik.handleChange}
                                        value={formik.values.vipadult}
                                        checked={formik.values.vipadult} name="vipadult" />}
                                    label="VIP Adult"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField
                                    style={{ width: 344 }}
                                    id="vipadultFee"
                                    name="vipadultFee"
                                    label="VIP Adult Fee"
                                    type="text"
                                    disabled={!formik.values.vipadult}
                                    onChange={formik.handleChange}
                                    value={formik.values.vipadultFee}
                                    error={formik.touched.vipadultFee && Boolean(formik.errors.vipadultFee)}
                                    helperText={formik.touched.vipadultFee && formik.errors.vipadultFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto" >
                            <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox

                                        onChange={formik.handleChange}
                                        value={formik.values.vipkid}
                                        checked={formik.values.vipkid} name="vipkid" />}
                                    label="VIP Kid"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField
                                    style={{ width: 344 }}
                                    id="vipkidFee"
                                    name="vipkidFee"
                                    label="VIP Kid Fee"
                                    type="text"
                                    disabled={!formik.values.vipkid}
                                    onChange={formik.handleChange}
                                    value={formik.values.vipkidFee}
                                    error={formik.touched.vipkidFee && Boolean(formik.errors.vipkidFee)}
                                    helperText={formik.touched.vipkidFee && formik.errors.vipkidFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto" >
                            <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox

                                        onChange={formik.handleChange}
                                        value={formik.values.gaadult}
                                        checked={formik.values.gaadult} name="gaadult" />}
                                    label="GA Adult"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField
                                    style={{ width: 344 }}
                                    id="gaadultFee"
                                    name="gaadultFee"
                                    label="GA Adult Fee"
                                    type="text"
                                    disabled={!formik.values.gaadult}
                                    onChange={formik.handleChange}
                                    value={formik.values.gaadultFee}
                                    error={formik.touched.gaadultFee && Boolean(formik.errors.gaadultFee)}
                                    helperText={formik.touched.gaadultFee && formik.errors.gaadultFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto" >
                            <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox

                                        onChange={formik.handleChange}
                                        value={formik.values.gakid}
                                        checked={formik.values.gakid} name="gakid" />}
                                    label="GA Kid"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField
                                    style={{ width: 344 }}
                                    id="gakidFee"
                                    name="gakidFee"
                                    label="GA Kid Fee"
                                    type="text"
                                    disabled={!formik.values.gakid}
                                    onChange={formik.handleChange}
                                    value={formik.values.gakidFee}
                                    error={formik.touched.gakidFee && Boolean(formik.errors.gakidFee)}
                                    helperText={formik.touched.gakidFee && formik.errors.gakidFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.twowheeler}
                                        checked={formik.values.twowheeler}
                                        name="twowheeler" />}
                                    label="two wheeler"
                                />

                            </Grid>

                            <Grid item xs>
                                <TextField style={{ width: 344 }}
                                    id="twowheelerFee"
                                    name="twowheelerFee"
                                    label="Two wheeler Fee"
                                    type="text"
                                    disabled={!formik.values.twowheeler}
                                    onChange={formik.handleChange}
                                    value={formik.values.twowheelerFee}
                                    error={formik.touched.twowheelerFee && Boolean(formik.errors.twowheelerFee)}
                                    helperText={formik.touched.twowheelerFee && formik.errors.twowheelerFee}
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.fourwheeler}
                                        checked={formik.values.fourwheeler}
                                        name="fourwheeler" />}
                                    label="four wheeler"
                                />

                            </Grid>

                            <Grid item xs>
                                <TextField style={{ width: 344 }}
                                    id="fourwheelerFee"
                                    name="fourwheelerFee"
                                    label="Four wheeler Fee"
                                    type="text"
                                    disabled={!formik.values.fourwheeler}
                                    onChange={formik.handleChange}
                                    value={formik.values.fourwheelerFee}
                                    error={formik.touched.fourwheelerFee && Boolean(formik.errors.fourwheelerFee)}
                                    helperText={formik.touched.fourwheelerFee && formik.errors.fourwheelerFee}
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto" >
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.seniorCitizen}
                                        checked={formik.values.seniorCitizen}
                                        name="seniorCitizen" />}
                                    label="Senior Citizen"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField
                                    style={{ width: 344 }}
                                    id="seniorCitizenFee"
                                    name="seniorCitizenFee"
                                    label="Senior Citizen Fee"
                                    type="text"
                                    disabled={!formik.values.seniorCitizen}
                                    onChange={formik.handleChange}
                                    value={formik.values.seniorCitizenFee}
                                    error={formik.touched.seniorCitizenFee && Boolean(formik.errors.seniorCitizenFee)}
                                    helperText={formik.touched.seniorCitizenFee && formik.errors.seniorCitizenFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto" >
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.women}
                                        checked={formik.values.women}
                                        name="women" />}
                                    label="Women"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField style={{ width: 344 }}
                                    id="womenFee"
                                    name="womenFee"
                                    label="Women Fee"
                                    disabled={!formik.values.women}
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.womenFee}
                                    error={formik.touched.womenFee && Boolean(formik.errors.womenFee)}
                                    helperText={formik.touched.womenFee && formik.errors.womenFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.physicallyChallenged}
                                        checked={formik.values.physicallyChallenged}
                                        name="physicallyChallenged" />}
                                    label="Physically Challenged"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField style={{ width: 344 }}
                                    id="physicallyChallengedFee"
                                    name="physicallyChallengedFee"
                                    label="Physically Challenged Fee"
                                    type="text"
                                    disabled={!formik.values.physicallyChallenged}
                                    onChange={formik.handleChange}
                                    value={formik.values.physicallyChallengedFee}
                                    error={formik.touched.physicallyChallengedFee && Boolean(formik.errors.physicallyChallengedFee)}
                                    helperText={formik.touched.physicallyChallengedFee && formik.errors.physicallyChallengedFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox

                                        onChange={formik.handleChange}
                                        value={formik.values.camera}
                                        checked={formik.values.camera}
                                        name="camera" />}
                                    label="Video Camera"
                                />

                            </Grid>

                            <Grid item xs>
                                <TextField style={{ width: 344 }}
                                    id="cameraFee"
                                    name="cameraFee"
                                    label="Camera Fee"
                                    type="text"
                                    disabled={!formik.values.camera}
                                    onChange={formik.handleChange}
                                    value={formik.values.cameraFee}
                                    error={formik.touched.cameraFee && Boolean(formik.errors.cameraFee)}
                                    helperText={formik.touched.cameraFee && formik.errors.cameraFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.photography}
                                        checked={formik.values.photography}
                                        name="photography" />}
                                    label="Photography"
                                />

                            </Grid>

                            <Grid item xs>
                                <TextField style={{ width: 344 }}
                                    id="photographyFee"
                                    name="photographyFee"
                                    label="Photography Fee"
                                    type="text"
                                    disabled={!formik.values.photography}
                                    onChange={formik.handleChange}
                                    value={formik.values.photographyFee}
                                    error={formik.touched.photographyFee && Boolean(formik.errors.photographyFee)}
                                    helperText={formik.touched.photographyFee && formik.errors.photographyFee}
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.shooting}
                                        checked={formik.values.shooting}
                                        name="shooting" />}
                                    label="Shooting"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField style={{ width: 344 }}
                                    id="shootingFee"
                                    name="shootingFee"
                                    label="Shooting Fee"
                                    disabled={!formik.values.shooting}
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.shootingFee}
                                    error={formik.touched.shootingFee && Boolean(formik.errors.shootingFee)}
                                    helperText={formik.touched.shootingFee && formik.errors.shootingFee}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.walker}
                                        checked={formik.values.walker}
                                        name="walker" />}
                                    label="Walker"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField style={{ width: 344 }}
                                    id="walkerFee"
                                    name="walkerFee"
                                    label="walker Fee"
                                    disabled={!formik.values.walker}
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.walkerFee}
                                    error={formik.touched.walkerFee && Boolean(formik.errors.walkerFee)}
                                    helperText={formik.touched.walkerFee && formik.errors.walkerFee}
                                />
                            </Grid>
                        </Grid>
         
                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.family}
                                        checked={formik.values.family}
                                        name="family" />}
                                        
                                    label="Family"
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField style={{ width: 344 }}
                                    id="familyFee"
                                    name="familyFee"
                                    label="Family Fee"
                                    disabled={!formik.values.family}
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.familyFee}
                                    error={formik.touched.familyFee && Boolean(formik.errors.familyFee)}
                                    helperText={formik.touched.familyFee && formik.errors.familyFee}
                                />
                            </Grid>
                            

                        </Grid>
                        {formik.values.family ?  <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>

                        <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.family && formik.values.familyAddon}
                                        checked={formik.values.family && formik.values.familyAddon}
                                        name="familyAddon" />}
                                    label="Family Addon"
                                />
                            </Grid>
                            <Grid item xs>
                                <TextField style={{ width: 344 }}
                                    id="familyAddonFee"
                                    name="familyAddonFee"
                                    label="Family AddonFee"
                                    disabled={!formik.values.familyAddon}
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.familyAddonFee}
                                    error={formik.touched.familyAddonFee && Boolean(formik.errors.familyAddonFee)}
                                    helperText={formik.touched.familyAddonFee && formik.errors.familyAddonFee}
                                />
                            </Grid>
                            </Grid>:""}

                        <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.isCloakRoom}
                                        checked={formik.values.isCloakRoom}
                                        name="isCloakRoom" />}
                                    label="Cloak Room Available"
                                />
                            </Grid>
                        </Grid> */}

                        {/* <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox
                                        onChange={formik.handleChange}
                                        value={formik.values.isHolidays}
                                        checked={formik.values.isHolidays}
                                        name="isHolidays" />}
                                    label="Holidays"
                                />
                            </Grid>
                        </Grid>
                        {formik.values.isHolidays ? (<Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                            <Grid item xs="auto">
                                <FormControlLabel style={{ width: 250 }}
                                    control={<Checkbox checked={checkboxes.isHolidays} onChange={handleCheckboxChange} name="isHolidays" />}
                                    label="Holidays"
                                />
                                <FormControl
                                    required

                                    component="fieldset"
                                    sx={{ m: 3 }}
                                    variant="standard"
                                >
                                    <FormLabel component="legend">Selecte Holiday</FormLabel>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={holidays.mon} onChange={handleHolidaysChange} name="mon" />
                                            }
                                            label="Mon"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={holidays.tue} onChange={handleHolidaysChange} name="tue" />
                                            }
                                            label="Tue"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={holidays.wed} onChange={handleHolidaysChange} name="wed" />
                                            }
                                            label="Wed"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={holidays.thu} onChange={handleHolidaysChange} name="thu" />
                                            }
                                            label="Thu"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={holidays.fri} onChange={handleHolidaysChange} name="fri" />
                                            }
                                            label="Fri"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={holidays.sat} onChange={handleHolidaysChange} name="sat" />
                                            }
                                            label="Sat"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={holidays.sun} onChange={handleHolidaysChange} name="sun" />
                                            }
                                            label="Sun"
                                        />
                                    </FormGroup>

                                </FormControl>
                            </Grid>


                        </Grid>) : ''} */}
                      
                       
                        <TextField
                            style={{ width: 427 }}
                            id="qrName"
                            name="qrName"
                            label="QR Name"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.qrName}
                            error={formik.touched.qrName && Boolean(formik.errors.qrName)}
                            helperText={formik.touched.qrName && formik.errors.qrName}
                        />

                        {/* New Fields Section */}
                        <div style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
                            <h4 style={{ color: '#ff6b81', marginBottom: '15px' }}>Additional Features</h4>
                            
                            {/* Coupon Enabled Checkbox */}
                            <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                                <Grid item xs="auto">
                                    <FormControlLabel style={{ width: 250 }}
                                        control={<Checkbox
                                            onChange={formik.handleChange}
                                            checked={formik.values.isEnabledCoupon}
                                            name="isEnabledCoupon" />}
                                        label="Enable Coupon"
                                    />
                                </Grid>
                            </Grid>

                            {/* Custom Booking Dates Section */}
                            <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                                <Grid item xs="auto">
                                    <FormControlLabel style={{ width: 250 }}
                                        control={<Checkbox
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                                if (!e.target.checked) {
                                                    formik.setFieldValue('bookingDates', []);
                                                } else {
                                                    // Initialize with empty array if undefined
                                                    if (!formik.values.bookingDates) {
                                                        formik.setFieldValue('bookingDates', []);
                                                    }
                                                }
                                            }}
                                            checked={formik.values.isEnabledCustomBookingDates}
                                            name="isEnabledCustomBookingDates" />}
                                        label="Enable Custom Booking Dates"
                                    />
                                </Grid>
                            </Grid>

                            {/* Booking Dates Array */}
                            {formik.values.isEnabledCustomBookingDates && (
                                <div style={{ marginLeft: '20px', marginTop: '10px' }}>
                                    <h5>Booking Dates:</h5>
                                    {(formik.values.bookingDates || []).map((date, index) => (
                                        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                            <TextField
                                                style={{ width: 300, marginRight: '10px' }}
                                                type="date"
                                                value={date ? new Date(date).toISOString().split('T')[0] : ''}
                                                onChange={(e) => {
                                                    const currentDates = formik.values.bookingDates || [];
                                                    const newDates = [...currentDates];
                                                    newDates[index] = e.target.value;
                                                    formik.setFieldValue('bookingDates', newDates);
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                            <Button
                                                variant="outlined"
                                                color="secondary"
                                                size="small"
                                                onClick={() => {
                                                    const currentDates = formik.values.bookingDates || [];
                                                    const newDates = currentDates.filter((_, i) => i !== index);
                                                    formik.setFieldValue('bookingDates', newDates);
                                                }}
                                                style={{ marginLeft: '10px', minWidth: '40px', padding: '8px' }}
                                            >
                                                <RemoveIcon />
                                            </Button>
                                        </div>
                                    ))}
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        onClick={() => {
                                            const currentDates = formik.values.bookingDates || [];
                                            const newDates = [...currentDates, ''];
                                            formik.setFieldValue('bookingDates', newDates);
                                        }}
                                        style={{ marginTop: '10px', minWidth: '40px', padding: '8px' }}
                                        startIcon={<AddIcon />}
                                    >
                                        Add Date
                                    </Button>
                                </div>
                            )}

                            {/* Home Banner Section */}
                            <Grid container alignContent="center" alignItems="center" direction="row" xs={12}>
                                <Grid item xs="auto">
                                    <FormControlLabel style={{ width: 250 }}
                                        control={<Checkbox
                                            onChange={formik.handleChange}
                                            checked={formik.values.isHomeBannerEnabled}
                                            name="isHomeBannerEnabled" />}
                                        label="Enable Home Banner"
                                    />
                                </Grid>
                            </Grid>

                            {/* Home Banner Image URL */}
                            {formik.values.isHomeBannerEnabled && (
                                <div style={{ marginLeft: '20px', marginTop: '10px' }}>
                                    <TextField
                                        style={{ width: 600 }}
                                        id="homeBannerImage"
                                        name="homeBannerImage"
                                        label="Home Banner Image URL"
                                        type="url"
                                        onChange={formik.handleChange}
                                        value={formik.values.homeBannerImage}
                                        error={formik.touched.homeBannerImage && Boolean(formik.errors.homeBannerImage)}
                                        helperText={formik.touched.homeBannerImage && formik.errors.homeBannerImage}
                                        placeholder="https://example.com/banner-image.jpg"
                                    />
                                </div>
                            )}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" >Add</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog 
            open={open1}
            onClose={handleClose1}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
           
          >
           {text}
          </Dialog>
        </>
    );

}


